import { render, staticRenderFns } from "./veStuReservationEdit.vue?vue&type=template&id=a2ba7596&scoped=true"
import script from "./veStuReservationEdit.vue?vue&type=script&lang=js"
export * from "./veStuReservationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ba7596",
  null
  
)

export default component.exports